import { Button, Checkbox } from "@material-ui/core";
import React from "react";
import Media from "react-media";
import { Route } from "react-router-dom";
import InfoDialog from "../../../components/dialog/InfoDialog";
import { HeaderDesktop } from "../../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../../components/header/mobile/HeaderMobile";
import { ProgressBar } from "../../../components/progress-bar/ProgressBar";
import { GoogleTagManagerService } from "../../../services/analitycs/GoogleTagManagerService";
import { SelectTerminalTypesState } from "../../../states/SelectTerminalTypesState";
import { TerminalOperationType } from "../../../utils/TerminalOperationTypeEnum";
import "./SelectTerminalTypes.css";

export class SelectTerminalTypes extends React.Component<
  any,
  SelectTerminalTypesState
> {
  private email = "";
  private description = "";
  constructor(props: any) {
    super(props);
    this.state = {
      mobilePosSelected: false,
      softPosSelected: false,
      showDialog: false,
      buttonDisabled: true,
    };
    this.email = this.props.location.state.email;
    this.description = this.props.location.state.description;
  }

  componentDidMount() {
    GoogleTagManagerService.getInstance().pushPageEvent(
      this.props.history.location.pathname,
      "Crea nuova utenza",
      {}
    );
  }

  private static renderDesktopHeader(): JSX.Element {
    return (
      <HeaderDesktop
        showBack={true}
        showLogout={false}
        showTitle={true}
        title={"Crea nuova utenza"}
      />
    );
  }
  private static renderMobileHeader(): JSX.Element {
    return (
      <HeaderMobile
        showBack={true}
        showLogout={false}
        showTitle={true}
        title={"Crea nuova utenza"}
      />
    );
  }
  private showDialogInfo() {
    this.toggleModal();
  }
  private toggleModal = () => {
    this.setState({
      showDialog: !this.state.showDialog,
    });
    GoogleTagManagerService.getInstance().pushPopupImpression(
      "gaEvent_PopupImpression",
      "nuova utenza dati dipendente",
      "impression",
      "cosa può fare il tuo staff"
    );
  };
  private goToThirdStep(history: any) {
    if (this.state.mobilePosSelected && !this.state.softPosSelected) {
      history.push("/chooseTerminal", {
        email: this.email,
        description: this.description,
        headerTitle: "Crea nuova utenza",
        tidOperation: TerminalOperationType.ADD_TERMINAL_ID_TO_USER,
        terminalType: "MPOS",
      });
    } else if (!this.state.mobilePosSelected && this.state.softPosSelected) {
      history.push("/chooseTerminal", {
        email: this.email,
        description: this.description,
        headerTitle: "Crea nuova utenza",
        tidOperation: TerminalOperationType.ADD_TERMINAL_ID_TO_USER,
        terminalType: "SOFTPOS",
      });
    } else {
      history.push("/chooseTerminal", {
        email: this.email,
        description: this.description,
        headerTitle: "Crea nuova utenza",
        alternativeTitle: "Prima assegna un ID Terminale Mobile POS",
        tidOperation: TerminalOperationType.CHOOSE_AGAIN,
        terminalType: "MPOS",
      });
    }
  }

  public renderBoxCheckbox(
    title: string,
    payOff: string,
    check: boolean,
    onChanged: Function
  ): JSX.Element {
    return (
      <div className="wrapper-check">
        <Checkbox checked={check} onChange={(e) => onChanged(e)} />
        <div className="box-text-check">
          <p className="user-text-check">{title}</p>
          <p className="info-text-check">{payOff}</p>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div id={"main-container-add-user"}>
        <ProgressBar value={66.66} />
        <Media
          query="(max-width: 1064px)"
          render={() => SelectTerminalTypes.renderMobileHeader()}
        />
        <Media
          query="(min-width: 1065px)"
          render={() => SelectTerminalTypes.renderDesktopHeader()}
        />

        <div className={"add-user-container-content"} id={"add-user-content"}>
          <div className={"add-user-content"}>
            <p className={"add-user-title"}>
              Seleziona i metodi di pagamento ai quali avrà accesso
            </p>
            <div className={"wrapper-typology-pos"}>
              {this.renderBoxCheckbox(
                "Mobile POS",
                "Accetta pagamenti utilizzando il lettore carte.",
                this.state.mobilePosSelected,
                (e: React.ChangeEvent<HTMLInputElement>) => {
                  this.setState({
                    ...this.state,
                    mobilePosSelected: e.target.checked,
                  });
                }
              )}
              {this.renderBoxCheckbox(
                "SoftPOS",
                "Accetta pagamenti direttamente sullo smartphone.",
                this.state.softPosSelected,
                (e: React.ChangeEvent<HTMLInputElement>) => {
                  this.setState({
                    ...this.state,
                    softPosSelected: e.target.checked,
                  });
                }
              )}
            </div>
          </div>
        </div>
        <div className="wrapper-cta">
          <Button
            id={"add-user-button-info"}
            onClick={() => {
              this.showDialogInfo();
            }}
            disableRipple>
            {"Cosa potrà fare questa utenza?".toUpperCase()}
          </Button>
          <Route
            render={({ history }) => {
              return (
                <Button
                  id={"add-user-go-to-next-step-button"}
                  type={"button"}
                  disabled={
                    !(
                      this.state.mobilePosSelected || this.state.softPosSelected
                    )
                  }
                  onClick={() => this.goToThirdStep(history)}>
                  AVANTI
                </Button>
              );
            }}
          />
        </div>
        {this.state.showDialog && (
          <InfoDialog
            show={this.state.showDialog}
            onClose={this.toggleModal}
            title={"Cosa potrà fare il tuo staff?"}
            content={
              "I tuoi dipendenti possono accettare pagamenti a nome della tua attività, accedere all’App con le proprie credenziali e vedranno solo le transazioni relative al ID Terminale a loro assegnato."
            }
            buttonText={"ok, ho capito"}
          />
        )}
      </div>
    );
  }
}
